import { Box, SvgIcon, Typography } from '@mui/material';
import LockIcon from 'mdi-react/LockIcon';
import { string } from 'prop-types';
import React, { memo } from 'react';
import { I18n } from 'utils/i18n';

const ReadOnly = ({ message }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '15px',
    }}
  >
    <SvgIcon color="secondary">
      <LockIcon />
    </SvgIcon>
    <Typography variant="caption">{message || I18n.t('Read-only channel')}</Typography>
  </Box>
);

ReadOnly.propTypes = {
  message: string,
};

export default memo(ReadOnly);
